"use client";
import DiscoverSection from "@/commonComponents/discover-section";
import { useState } from "react";
import GalleryDialog, {
  LeaderSlideProps,
} from "@/commonComponents/gallery-dialog";
import { H1 } from "@/styles/theme/components/typography.fontvariant";

export type GalleryProps = {
  data: {
    title: string;
    imageData: LeaderSlideProps[];
  };
};

const Gallery = (props: GalleryProps) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setactiveIndex] = useState(0);

  const { title, imageData } = props.data;
  return (
    <>
      <DiscoverSection
        title={title}
        ImageData={imageData}
        bgcolor="default"
        color="primary.main"
        clickableSlides
        onImageClick={(index) => {
          setOpen(true);
          setactiveIndex(index);
        }}
        TitleTypographyProps={{
          fontSize: H1,
        }}
      />
      <GalleryDialog
        open={open}
        setOpen={setOpen}
        data={imageData}
        activeIndex={activeIndex}
        fullImage
        MainImageProps={{
          width: 1078,
          height: 592,
          sx: {
            width: "100%",
            height: { xs: 423, md: 592 },
            objectFit: "cover",
            // objectPosition: "top",
          },
        }}
        MiniSwiperWrapperProps={{
          ".swiper-wrapper": {
            justifyContent: "flex-start",
          },
        }}
      />
    </>
  );
};

export default Gallery;
